import { Attr, HasMany, HasOne, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type FilteredSpecStream from "./FilteredSpecStream";
import type OrganisationReportSpec from "./OrganisationReportSpec";

@Model()
class OrganisationReportFilteredSpec extends ApplicationRecord {
  static jsonapiType = "organisation_report_filtered_specs";

  @Attr({ persist: false }) archivedAt: string;

  @Attr() deliverAt: number;

  @Attr() deliverWithReport: boolean;

  @Attr() distributionListId: number;

  @Attr() enabled: boolean;

  @Attr() filters: any[];

  @HasMany() folders: FilteredSpecStream[];

  @Attr() organisationBrandId: number;

  @Attr() prefillEmptyFolders: boolean;

  @Attr() recipients: any[];

  @Attr() sources: any[];

  @HasOne() specification: OrganisationReportSpec;

  @Attr() subject: string;
}

export default OrganisationReportFilteredSpec;
